<template>
  <div>
    <vue-toastr ref="toast"></vue-toastr>
    <div v-for="(item, index) in items" :key="item.id || 'new-' + index" class="form-inline mb-2" style="display: flex; align-items: center; flex-wrap: nowrap;">
      <span style="margin-right: 10px; white-space: nowrap;">Status {{ item.level_number }} ab</span>
      <input v-model.number="item.points_threshold" class="form-control" type="number" min="0" style="width: 100px; margin-right: 10px;">
      <span style="margin-right: 10px; white-space: nowrap;">Punkte mit Ausschüttung von</span>
      <input v-model.number="item.bonus_points" class="form-control" type="number" min="0" style="width: 100px; margin-right: 10px;">
      <span style="margin-right: 15px; white-space: nowrap;">Punkten</span>
      <button :disabled="saving" class="btn btn-outline btn-danger btn-sm" type="button" @click="deleteItem(index)">
        <i class="fa fa-trash"></i>
      </button>
    </div>
    <button class="btn btn-outline btn-info btn-sm mt-2" type="button" @click="addItem">
      <i class="fa fa-plus"></i> Weiteren Status hinzufügen
    </button>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import axios from "axios";

export default {
  name: "SimulationStatusLevels",
  components: {VueToastr},
  data() {
    return {
      items: [],
      saving: false,
    };
  },
  props: {
    variantId: {
      type: [String, Number],
      required: true,
    },
    initialItems: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.items = this.initialItems.map((item, index) => ({
      id: item.id,
      level_number: index + 1,
      points_threshold: item.points_threshold,
      bonus_points: item.bonus_points,
      customers_reached: item.customers_reached,
    }));
  },
  methods: {
    addItem() {
      const nextLevelNumber = this.items.length > 0
        ? Math.max(...this.items.map(i => i.level_number)) + 1
        : 1;

      this.items.push({
        id: null,
        level_number: nextLevelNumber,
        points_threshold: null,
        bonus_points: null,
      });
    },
    getItems() {
      return this.items
        .filter(item => item.points_threshold !== null && item.bonus_points !== null)
        .map(item => ({
          id: item.id || null,
          points_threshold: item.points_threshold,
          bonus_points: item.bonus_points,
        }));
    },
    updateItems(items) {
      this.items = items.map((item, index) => ({
        id: item.id,
        level_number: index + 1,
        points_threshold: item.points_threshold,
        bonus_points: item.bonus_points,
        customers_reached: item.customers_reached,
      }));
    },
    async deleteItem(index) {

      if (!confirm("Möchten Sie diese Statusstufe wirklich löschen?")) {
        return;
      }

      this.items.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.mb-2 {
  margin-bottom: 10px;
}
.mt-2 {
  margin-top: 10px;
}
</style>
